import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Messaging from './Messaging';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import HamQuest from '../../api/HamQuestGiver';
import { userRoles } from '../../RoleProtected';

const Settings = ({ ...props }) => {
    return (
        <PageBreak>
            <PageBreak tab='Settings'>
                <FormSetting
                    name='expressPassNameSettings'
                    label='Custom Program Names'
                    info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
                    text='Update'
                    getInputs={QuestRoute.expressPass.programNames}
                    onSubmit={e => HamQuest.put(QuestRoute.expressPass.programNames, e)}
                    editable
                    roles={userRoles.editProducts}
                >
                    <Input
                        label='Daily Pass'
                        name='dailyPass'
                        required
                    />
                    <Input
                        label='PrePaid Passes'
                        name='prepaidPass'
                        required
                    />
                    <Input
                        label='Fleet Passes'
                        name='fleetPass'
                        required
                    />

                </FormSetting>

                <FormSetting
                    name='expressPassSettings'
                    label='Settings'
                    info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
                    text='Update'
                    getInputs={QuestRoute.expressPass.settings}
                    onSubmit={e => HamQuest.put(QuestRoute.expressPass.settings, { ...e })}
                    editable
                    roles={userRoles.editProducts}
                >
                    <Select
                        label='Offline Processing'
                        name='offlineProcessingMode'
                        required
                    >
                        <option value='Enable'>Enable</option>
                        <option value='Disable'>Disable</option>
                    </Select>
                    <Input
                        label='Loyalty Offline Duration (hours)'
                        type='number'
                        name='loyaltyOfflineDuration'
                        min={1}
                        max={72}
                        required
                    />
                    <Select
                        label='Default Max Use Period'
                        options={HSOptions.expressPass.maxUsePeriod}
                        name='passMaxUsePeriod'
                        required
                    />
                    <Input
                        label='Default Max Uses'
                        type='number'
                        min={1}
                        name='passMaxUses'
                        required
                    />
                    <Input
                        label='Default Pass Reuse Inhibit Time (min)'
                        type='number'
                        min={0}
                        name='passReuseInhibitTime'
                        required
                    />
                    <Select
                        label='Receipt Mode'
                        options={HSOptions.expressPass.receiptMode}
                        name='receiptMode'
                        required
                    />
                </FormSetting>
            </PageBreak>

            <Messaging />

        </PageBreak>
    );
}

export default Settings;